<template>
  <a-card :bordered="false">
    <a-row>
      <a-col span="12" class="topTitle">会员买码支付方案</a-col>
      <a-col span="12">
        <a-button type="primary" @click="editType=true" v-if="!editType">编辑</a-button>
        <a-button @click="editType=false" v-if="editType">取消</a-button>
        <a-button type="primary" v-if="editType" @click="save" class="ml10">保存</a-button>
      </a-col>
    </a-row>
    <a-form class="mt10" style="width: 900px;">
      <a-row :gutter="48" class="flex">
        <a-col span="5">
          新用户赠送云码数量
        </a-col>
        <a-col :md="6" :sm="24" style="display: flex;align-items: center;">
          <a-input style="width: 200px;" :disabled="!editType" v-model="count"></a-input>
          <div class="ml10">个</div>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10">
        <a-col span="5">
          新用户赠送时间
        </a-col>
        <a-col :md="6" :sm="24" style="display: flex;align-items: center;">
          注册完成后赠送一年时间
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5">
          续费价格
        </a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            标准服务：
            <a-input style="width: 200px;" v-model="buyPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5"></a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            延保服务：
            <a-input style="width: 200px;" v-model="buyMaintainPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5"></a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            报修服务：
            <a-input style="width: 200px;" v-model="buyRepairPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row class="mt10">
        <a-col span="5"></a-col>
        <a-col style="margin-left: 4px;font-size: 12px;color: #ccc;">&nbsp&nbsp买码会员需对账户云码数量进行预充值，只有在账户有剩余云码的情况下才可以打印新的云码</a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex" style="height: 40px;">
        <a-col span="5">
          充值云码方案
        </a-col>
        <a-col :md="6" :sm="24" span="48">
          <a-button @click="add" v-if="editType">新增一条</a-button>
          <div v-else></div>
        </a-col>
      </a-row>
      <a-row class="mt10">
        <a-col class="flex flex_w">
          <a-card style="width: 150px;" v-for="(item, index) in arr" :key="index" class="mr20 mt10">
            <div class="flex">
              <a-input :disabled="!editType" v-model="item.count"></a-input>
              <div class="ml10">张</div>
            </div>
            <div >
              <img @click="deleteArrs(index)" v-if="editType" style="width: 18px;height: 18px;margin-left: 90px;" src="../../assets/images/delete.png" alt="">
              <div v-else style="width: 18px;height: 18px;margin-left: 90px;"></div>
            </div>
            <div class="flex">
              <a-input :disabled="!editType" v-model="item.price"></a-input>
              <div class="ml10">元</div>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-row style="margin-top: 60px;">
        <a-col span="12" class="topTitle">无限码支付方案</a-col>
      </a-row>
      <a-row :gutter="48" class="mt10">
        <a-col span="5">
          新用户赠送时间
        </a-col>
        <a-col :md="6" :sm="24" style="display: flex;align-items: center;">
          注册完成后赠送一年时间
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5">
          续费价格
        </a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            标准服务：
            <a-input style="width: 200px;" v-model="setPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5"></a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            延保服务：
            <a-input style="width: 200px;" v-model="setMaintainPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5"></a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            报修服务：
            <a-input style="width: 200px;" v-model="setRepairPrice" :disabled="!editType"></a-input>
            <div class="ml10">元/年</div>
          </div>
        </a-col>
      </a-row>
      <a-row class="mt10">
        <a-col span="5"></a-col>
        <a-col style="margin-left: 4px;font-size: 12px;color: #ccc;">&nbsp&nbsp高级会员账户可无限制生成云码，故无需预充值</a-col>
      </a-row>
      <a-row style="margin-top: 60px;">
        <a-col span="12" class="topTitle">提现设置</a-col>
      </a-row>
      <a-row :gutter="48" class="mt10 flex">
        <a-col span="5">
          提现手续费
        </a-col>
        <a-col span="12">
          <div style="display: flex;align-items: center;">
            <a-input-number
              v-model="withdrawal_service_charge"
              :min="0"
              :max="100"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              :disabled="!editType"
            />
          </div>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>
<script>
import { rechargeSave, rechargePre } from '@/api/programme'
import DetailList from '@/components/DescriptionList'
import _ from 'lodash'
export default {
  components: {
    DetailList
  },
  name: 'Code',
  data () {
    return {
      arr: '',
      buyPrice: '',
      buyMaintainPrice: '',
      buyRepairPrice: '',
      count: '',
      setPrice: '',
      setMaintainPrice: '',
      setRepairPrice: '',
      withdrawal_service_charge: '',
      editType: false
    }
  },
  mounted() {
    this.getPre()
  },
  methods: {
    save () {
      const params = {
        new_buyer_give_count: this.count,
        buyer_annual_price: this.buyPrice,
        buyer_maintain_price: this.buyMaintainPrice,
        buyer_repair_price: this.buyRepairPrice,
        forever_annual_price: this.setPrice,
        forever_maintain_price: this.setMaintainPrice,
        forever_repair_price: this.setRepairPrice,
        withdrawal_service_charge: this.withdrawal_service_charge,
        price_setting: this.arr
      }
      rechargeSave(params).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('保存成功')
          this.editType = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getPre () {
      rechargePre().then(res => {
        console.log(res)
        if (_.get(res, 'code') === 200) {
          const data = _.get(res, 'data', [])
          this.buyPrice = data.buyer_annual_price
          this.buyMaintainPrice = data.buyer_maintain_price
          this.buyRepairPrice = data.buyer_repair_price
          this.count = data.new_buyer_give_count
          this.setPrice = data.forever_annual_price
          this.setMaintainPrice = data.forever_maintain_price
          this.setRepairPrice = data.forever_repair_price
          this.withdrawal_service_charge = data.withdrawal_service_charge
          this.arr = data.price_setting
        }
      })
    },
    add () {
      const newArr = {
        count: '0',
        price: '0'
      }
      this.arr.push(newArr)
    },
    deleteArrs (index) {
      this.arr.splice(index, 1)
    }
  }
}
</script>

<style scoped>
  .flex {
    display: flex;
    align-items: center;
  }
  .flex_w {
    flex-wrap: wrap;
  }
  .topTitle {
  font-weight: 700;
  font-size: 18px;
}
  .mt10 {
    margin-top: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .ml10 {
    margin-left: 10px;
  }
  .mr20 {
    margin-right: 20px;
  }
</style>
